import { useState } from "react";
import { Alert, Button, Paper } from "@mui/material";
import { Link } from "react-router-dom";
import CustomeLayout from "../../../../shared/ui/customeTable";
import Filters from "../../../../shared/ui/filters";
import usePromotionReservations from "../../hooks/use-promotion-reservations";
import ReservationDialog from "./ReservationDialog";
import { promotionAmount } from "../../lib/promotion-amount";

const ignored = () => {};
const labels = { draft: "پیش‌نویس", held: "در انتظار پرداخت", pending: "پرداخت در انتظار تأیید", paid: "پرداخت‌شده",
  failed: "پرداخت ناموفق", stopped: "نمایش متوقف", refunded: "بازپرداخت‌شده" };
export default function ReservationPanel({ bannersOnly = false }) {
  const catalogue = usePromotionReservations(bannersOnly);
  const [editing, setEditing] = useState(null), [search, setSearch] = useState("");
  const now = catalogue.serverNow ?? Date.now();
  const rows = catalogue.rows.map((item) => ({ ...item,
    customerUserId: <Link to={`/users/${item.customerUserId}`}>کاربر {item.customerUserId}</Link>,
    boothId: item.boothId,
    amountDisplay: `${promotionAmount(item.amountMinor, item.currency)}${item.refundedAmountMinor ? ` (برگشت: ${promotionAmount(item.refundedAmountMinor, item.currency)})` : ""}`,
    startsDisplay: new Date(item.startsAt).toLocaleString("fa-IR"), endsDisplay: new Date(item.endsAt).toLocaleString("fa-IR"),
    remainingDisplay: `${Math.max(0, Math.ceil((Date.parse(item.endsAt) - Math.max(now, Date.parse(item.startsAt))) / 86400000))} روز`,
    stateDisplay: item.refundPending ? "بازپرداخت در انتظار تأیید" : item.state === "refunded" ? labels.refunded : item.stopped ? labels.stopped : item.state === "paid"
      ? Date.parse(item.endsAt) <= now ? "منقضی" : Date.parse(item.startsAt) > now ? "رزروشده" : "فعال" : labels[item.state] }));
  const schema = catalogue.headers.filter((item) => item.name === "state" && item.hasFilter).map((item) => ({
    name: "state", title: item.title, type: "enum", options: Object.entries(labels).map(([value, title]) => ({ value, title })) }));
  return <div className="md:mx-3 mx-1">
    <Paper variant="outlined" className="p-4 mb-3 flex flex-wrap gap-3 justify-between">
      <Filters schema={schema} value={catalogue.query} loading={catalogue.loading} onApply={catalogue.apply} />
      <Button onClick={catalogue.reload}>بارگذاری مجدد</Button>
    </Paper>
    {catalogue.error && <Alert severity="error">{catalogue.error}</Alert>}
    <CustomeLayout title={bannersOnly ? "بنرهای تبلیغاتی" : "سفارش‌های تبلیغاتی"} headers={catalogue.headers} rows={rows}
      loading={catalogue.loading} length={catalogue.error ? null : catalogue.total}
      limit={catalogue.query.limit} setLimit={(limit) => catalogue.apply({ limit: Number(limit) })}
      paginationMode={2} page={catalogue.query.page} setPage={catalogue.page} total_pages={Math.max(1, Math.ceil(catalogue.total / catalogue.query.limit))}
      search={search} setSearch={setSearch} setApplySearch={(search) => catalogue.apply({ search })}
      setRefresh={catalogue.reload} selected={[]} setSelected={ignored} canSelect={false} currentRow={ignored}
      setting={{ TableType: "table" }} setAllRows={ignored} setSort={ignored}
      actions={[{ title: "عملیات", handler: (row) => <Button onClick={() => setEditing(catalogue.rows.find((item) => item.id === row.id))}>جزئیات و مدیریت</Button> }]} />
    <ReservationDialog row={editing} close={() => setEditing(null)} catalogue={catalogue} />
  </div>;
}
